angular.module('unica_location.location_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider

		// LOCATION
		.state('app.location', {
			url: '/location',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/location/templates/location.html',
					controller: 'LocationBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// LOCATION LIST AND DELETE
			.state('app.location.list', {
				url: '/list',
				views: {
					'locationContent': {
						templateUrl: './modules/location/templates/list.html',
						controller: 'LocationListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Locations'
				}
			})

			// LOCATION CREATE
			.state('app.location.create', {
				url: '/create',
				views: {
					'locationContent': {
						templateUrl: './modules/location/templates/create.html',
						controller: 'LocationCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Location',
					parent: 'app.location.list'
				}
			})

			// LOCATION EDIT
			.state('app.location.edit', {
				url: '/edit/:id',
				views: {
					'locationContent': {
						templateUrl: './modules/location/templates/edit.html',
						controller: 'LocationEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Location',
					parent: 'app.location.list'
				}
			});


});

